import { Controller } from "@hotwired/stimulus"

// Storefront faceted-catalogue form. Auto-submits the GET form (inside a
// turbo-frame) whenever a facet changes, stripping empty filter inputs first so
// the shared URL stays clean. Turbo reloads only the catalog frame and advances
// the URL, giving live counts + shareable, back-button-friendly state. On mobile
// the facet sidebar is an off-canvas drawer toggled by the Filters button.
export default class extends Controller {
  static targets = ["facets", "overlay"]

  connect() {
    this.onKeydown = (event) => { if (event.key === "Escape") this.closeFilters() }
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
    document.body.style.overflow = ""
  }

  submit() {
    this.stripEmpty()
    if (this.element.requestSubmit) {
      this.element.requestSubmit()
    } else {
      this.element.submit()
    }
  }

  toggleFilters() {
    if (!this.hasFacetsTarget) return
    const open = this.facetsTarget.classList.toggle("catalog__facets--open")
    if (this.hasOverlayTarget) this.overlayTarget.classList.toggle("catalog__overlay--open", open)
    document.body.style.overflow = open ? "hidden" : ""
  }

  closeFilters() {
    if (this.hasFacetsTarget) this.facetsTarget.classList.remove("catalog__facets--open")
    if (this.hasOverlayTarget) this.overlayTarget.classList.remove("catalog__overlay--open")
    document.body.style.overflow = ""
  }

  stripEmpty() {
    this.element.querySelectorAll("input, select").forEach((el) => {
      const isFilter = /^f\[/.test(el.name || "")
      const isEmpty = el.value === "" || el.value == null
      if (isFilter && el.type !== "checkbox" && isEmpty) {
        el.disabled = true
      }
    })
  }
}
